import { useRoutes } from "react-router-dom";
import { AboutUs } from "@/pages/About";
import { ContactUs } from "@/pages/Contact";
import { Pricing } from "@/pages/Pricing";
import { Introduction } from "@/pages/Introduction";
import { Products } from "@/pages/Products";
import { Resource } from "@/pages/Resource";
import { Register } from "@/pages/Register";
import { ChangePassword } from "@/pages/User/changePassword";
import { Login } from "@/pages/Login";
import { ForgotPassword } from "@/pages/Login/forgotPassword";
import { ResetPassword } from "../pages/Login/resetPassword";
import { ERR404 } from "@/pages/Error";
import { Admin } from "@/pages/Management";
import { Company } from "@/pages/Management/Company";
import { Settings } from "@/pages/Management/Settings";
import { BankConnections } from "@/pages/Management/BankConnections";
import { JobManagement } from "@/pages/Management/JobManagement";
import { JobLogs } from "@/pages/Management/JobLogs";
import { System } from "@/pages/Management/System";
import { Home as UserHome } from "@/pages/Home";
import { CompanyProfile } from "@/pages/Home/CompanyProfile";
import { Items, Inventory, Recall, InventoryAdjustment, InvAdjustmentAdd, InvAdjustmentInfo, InvNewInventoryAdd, InvNewInventoryInfo, InvMovementAdd, InvMovementInfo } from "@/pages/Home/Material";
import { Vendor, PO, Receipt, Bill } from "@/pages/Home/Purchasing";
import { Customer, SaleOrder, SOPickOrder, SOFulfillment, Invoice } from "@/pages/Home/Sales";
import { ChartOfAccounts, JournalEntry, Transaction, Reconciliation } from "@/pages/Home/Accounting";
import { BillOfMaterial, WorkOrder, WoPickOrder, WoFulfillment } from "@/pages/Home/Manufacturing";
import {
    SalesForecast,
    IncomeStatement,
    BalanceSheet,
    InventoryEvaluation,
    OpenPOReport,
    OpenSOReport,
    SalesReport,
    LastSales,
    SOPickingReport,
    SOFulfillmentReport,
    InventoryByLot,
    SaleHistory,
} from "@/pages/Home/Report";
import { BankConnection } from "@/pages/Home/Banking";
import { Warehouse } from "@/pages/Home/Settings";

const routeConfig = [
    { path: "/", element: <Introduction /> },
    { path: "/index.html", element: <Introduction /> },
    { path: "products", element: <Products /> },
    { path: "pricing", element: <Pricing /> },
    { path: "about", element: <AboutUs /> },
    { path: "contact", element: <ContactUs /> },
    { path: "resource", element: <Resource /> },
    { path: "register", element: <Register /> },
    { path: "login", element: <Login /> },
    { path: "forgot-password", element: <ForgotPassword /> },
    { path: "reset-password", element: <ResetPassword /> },
    {
        path: "workspace",
        element: <UserHome />,
        children: [
            { path: "material/items", element: <Items /> },
            { path: "material/items/add", element: <Items.Add /> },
            { path: "material/items/:itemId", element: <Items /> },
            { path: "material/items/:itemId/edit", element: <Items.Edit /> },
            // { path: "material/boms", element: <BOMs /> },
            { path: "material/inventory", element: <Inventory /> },
            { path: "material/inventory_adjustment", element: <InventoryAdjustment /> },
            { path: "material/inventory_adjustment/new", element: <InvAdjustmentAdd /> },
            { path: "material/inventory_adjustment/new_inventory", element: <InvNewInventoryAdd /> },
            { path: "material/inventory_adjustment/:id", element: <InvAdjustmentInfo /> },
            { path: "material/inventory_new_inventory/:id", element: <InvNewInventoryInfo /> },
            { path: "material/inventory_movement/new", element: <InvMovementAdd /> },
            { path: "material/inventory_movement/:id", element: <InvMovementInfo /> },
            { path: "material/recall", element: <Recall /> },
            { path: "purchasing/vendor", element: <Vendor /> },
            { path: "purchasing/vendor/add", element: <Vendor.Add /> },
            { path: "purchasing/vendor/:vendorId", element: <Vendor.Info /> },
            { path: "purchasing/vendor/:vendorId/edit", element: <Vendor.Edit /> },
            { path: "purchasing/po", element: <PO /> },
            { path: "purchasing/po/add", element: <PO.Add /> },
            { path: "purchasing/po/:poId", element: <PO.Info /> },
            { path: "purchasing/po/:poId/edit", element: <PO.Edit /> },
            { path: "purchasing/receipt", element: <Receipt /> },
            { path: "purchasing/receipt/po/:poId", element: <Receipt.Add /> },
            { path: "purchasing/receipt/:receiptId", element: <Receipt.Info /> },
            { path: "purchasing/receipt/:receiptId/edit", element: <Receipt.Edit /> },
            { path: "purchasing/bills", element: <Bill /> },
            { path: "purchasing/bills/receipt/:receiptId", element: <Bill.Add /> },
            { path: "purchasing/bills/blank", element: <Bill.Add /> },
            { path: "purchasing/bills/:billId", element: <Bill.Info /> },
            { path: "purchasing/bills/:billId/edit", element: <Bill.Edit /> },
            { path: "sales/customer", element: <Customer /> },
            { path: "sales/customer/add", element: <Customer.Add /> },
            { path: "sales/customer/:customerId", element: <Customer.Info /> },
            { path: "sales/customer/:customerId/edit", element: <Customer.Edit /> },
            { path: "sales/so", element: <SaleOrder /> },
            { path: "sales/so/add", element: <SaleOrder.Add /> },
            { path: "sales/so/:soId", element: <SaleOrder.Info /> },
            { path: "sales/so/:soId/edit", element: <SaleOrder.Edit /> },
            { path: "sales/so-pick-order", element: <SOPickOrder /> },
            { path: "sales/so-pick-order/:poId", element: <SOPickOrder.Info /> },
            { path: "sales/so-pick-order/:poId/edit", element: <SOPickOrder.Edit /> },
            { path: "sales/so-pick-order/so/:soId", element: <SOPickOrder.Add /> },
            { path: "sales/so-fulfillment", element: <SOFulfillment /> },
            { path: "sales/so-fulfillment/:fulfillmentId", element: <SOFulfillment.Info /> },
            { path: "sales/so-fulfillment/:fulfillmentId/edit", element: <SOFulfillment.Edit /> },
            { path: "sales/so-fulfillment/so/:soId", element: <SOFulfillment.Add /> },
            { path: "sales/invoice", element: <Invoice /> },
            { path: "sales/invoice/blank", element: <Invoice.Blank /> },
            { path: "sales/invoice/:invoiceId", element: <Invoice.Info /> },
            { path: "sales/invoice/:invoiceId/edit", element: <Invoice.Edit /> },
            { path: "sales/invoice/so/:soId", element: <Invoice.Add /> },
            { path: "accounting/coa", element: <ChartOfAccounts /> },
            { path: "accounting/journal-entry", element: <JournalEntry /> },
            { path: "accounting/journal-entry/:entryId", element: <JournalEntry.Info /> },
            { path: "accounting/journal-entry/new-entry", element: <JournalEntry.Add /> },
            { path: "accounting/transaction", element: <Transaction /> },
            { path: "accounting/reconciliation", element: <Reconciliation /> },
            { path: "accounting/reconciliation/:reconciliationId", element: <Reconciliation.Detail /> },
            { path: "manufacturing/bom", element: <BillOfMaterial /> },
            { path: "manufacturing/bom/add", element: <BillOfMaterial.Add /> },
            { path: "manufacturing/bom/:bomId", element: <BillOfMaterial.Info /> },
            { path: "manufacturing/bom/:bomId/edit", element: <BillOfMaterial.Edit /> },
            { path: "manufacturing/work-order", element: <WorkOrder /> },
            { path: "manufacturing/work-order/add", element: <WorkOrder.Add /> },
            { path: "manufacturing/work-order/:woId", element: <WorkOrder.Info /> },
            { path: "manufacturing/work-order/:woId/edit", element: <WorkOrder.Edit /> },
            { path: "manufacturing/wo-pick-order", element: <WoPickOrder /> },
            { path: "manufacturing/wo-pick-order/:poId", element: <WoPickOrder.Info /> },
            { path: "manufacturing/wo-pick-order/:poId/edit", element: <WoPickOrder.Edit /> },
            { path: "manufacturing/wo-pick-order/wo/:woId", element: <WoPickOrder.Add /> },
            { path: "manufacturing/wo-fulfillment", element: <WoFulfillment /> },
            { path: "manufacturing/wo-fulfillment/add/:workOrderId", element: <WoFulfillment.Add /> },
            { path: "manufacturing/wo-fulfillment/:id", element: <WoFulfillment.Info /> },
            { path: "manufacturing/wo-fulfillment/:id/edit", element: <WoFulfillment.Edit /> },
            { path: "reporting/sales-forecast", element: <SalesForecast /> },
            { path: "reporting/income-statement", element: <IncomeStatement /> },
            { path: "reporting/balance-sheet", element: <BalanceSheet /> },
            { path: "reporting/inventory-evaluation", element: <InventoryEvaluation /> },
            { path: "reporting/open-po-report", element: <OpenPOReport /> },
            { path: "reporting/open-so-report", element: <OpenSOReport /> },
            { path: "reporting/open-so-report-by-item", element: <OpenSOReport.ReportByItem /> },
            { path: "reporting/sales-report", element: <SalesReport /> },
            { path: "reporting/last-sales", element: <LastSales /> },
            { path: "reporting/sale-history", element: <SaleHistory /> },
            { path: "reporting/so-picking-report", element: <SOPickingReport /> },
            { path: "reporting/so-fulfillment-report", element: <SOFulfillmentReport /> },
            { path: "reporting/inventory-by-lot", element: <InventoryByLot /> },
            { path: "banking/bank-connection", element: <BankConnection /> },
            { path: "settings/warehouse", element: <Warehouse /> },
            { path: "settings/warehouse/:warehouseId", element: <Warehouse.Info /> },
            { path: "company/profile", element: <CompanyProfile /> },
            { path: "password", element: <ChangePassword /> },
            { index: true, element: <Items /> }
        ]
    },
    {
        path: "management",
        element: <Admin />,
        children: [
            { path: "company", element: <Company /> },
            { path: "bank-connections", element: <BankConnections /> },
            { path: "password", element: <ChangePassword /> },
            { index: true, element: <Company /> }
        ]
    },
    {
        path: "management/system",
        element: <System />,
        children: [
            { path: "settings", element: <Settings /> },
            { path: "jobs", element: <JobManagement /> },
            { path: "jobs/logs", element: <JobLogs /> },
            { index: true, element: <Settings /> }
        ]
    },
    {
        path: "*",
        element: <ERR404 />,
    },
]

const Routers = () => {
    const elements = useRoutes(routeConfig);
    return (
        <div className="router-items">
            {elements}
        </div>
    );
}

export default Routers;